import type { WithActiveBranchId } from '@app/api/shared';

export enum SalesFunnelStageLeadEndpoints {
  Add = 'Add',
  AddOrExchangeRange = 'AddOrExchangeRange',
  AddOrExchangeRangeBySearchId = 'AddOrExchangeRangeBySearchId',
  Exchange = 'Exchange',
  Delete = 'Delete',
}

export interface SalesFunnelStageFilterListDto {
  Id: number;
  Name: string | null;
  Color: string | null;
}

export type AddSalesFunnelStageLeadRequest = WithActiveBranchId<{
  leadId: number;
  funnelStageId: number;
}>;

export type AddOrExchangeRangeSalesFunnelStageLeadRequest = WithActiveBranchId<{
  funnelStageId: number;
  data: number[];
}>;

export type AddOrExchangeRangeBySearchIdSalesFunnelStageLeadRequest =
  WithActiveBranchId<{
    // int64 в query-параметре: передаём строкой, чтобы не потерять точность
    searchId: string;
    funnelStageId: number;
  }>;

export type ExchangeSalesFunnelStageLeadRequest = WithActiveBranchId<{
  leadId: number;
  newFunnelStageId: number;
}>;

export type DeleteSalesFunnelStageLeadRequest = WithActiveBranchId<{
  leadId: number;
  funnelStageId: number;
}>;

export type AddSalesFunnelStageLeadResponse = SalesFunnelStageFilterListDto;
export type AddOrExchangeRangeSalesFunnelStageLeadResponse = void;
export type AddOrExchangeRangeBySearchIdSalesFunnelStageLeadResponse = void;
export type ExchangeSalesFunnelStageLeadResponse =
  SalesFunnelStageFilterListDto;
export type DeleteSalesFunnelStageLeadResponse = void;
